export const USER_GROUP = {
  SUPER_ADMIN :1,
  ADMINISTRATOR :2,
  BUSINESS_USER :3,
  MANAGER :4,
  SUPERVISOR :5,
  DISTRIBUTOR_USER :6,
  FIELD_USER :7
}
